/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { font, colors, spacing, zindex } from '@chegg-ui/theme';
import styled from 'styled-components'; // This wrapper is to handle safari issue
// safari expose area equal to box shadow where inner li element trigger mouse events outside parent UL.

export var ListboxContainer = styled.div.withConfig({
  componentId: "qq69hw-0"
})(["position:absolute;left:0;right:0;box-shadow:0 0 16px rgba(34,34,34,0.24);z-index:", ";", ";", ";"], zindex.dropdown, function (_ref) {
  var dropup = _ref.dropup;
  return dropup ? "\n    bottom: 100%;\n  " : "\n    top: 100%;\n  ";
}, function (_ref2) {
  var isOpen = _ref2.isOpen;
  return !isOpen && "\n     display: none;\n  ";
});
export var ListboxOptions = styled.ul.withConfig({
  componentId: "qq69hw-1"
})(["font-family:", ";color:", ";font-size:inherit;background-color:", ";outline:0px;height:auto;max-height:", ";margin:0;padding:0;overflow-y:auto;list-style-type:none;"], font.family["default"], colors.dark, colors.white, function (_ref3) {
  var maxHeight = _ref3.maxHeight;
  return maxHeight;
});
export var ListboxItem = styled.li.withConfig({
  componentId: "qq69hw-2"
})(["cursor:pointer;display:block;line-height:", ";font-size:", ";padding:", " ", ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;outline:0px;&:hover{background:", ";color:", ";}", ";", " ", ""], font.lineHeight.xs, font.size.px18, spacing.px12, spacing.px16, colors.dark, colors.white, function (_ref4) {
  var isKeyboardHover = _ref4.isKeyboardHover,
      isFocused = _ref4.isFocused;
  return isFocused && isKeyboardHover && "\n    background: ".concat(colors.dark, ";\n    color: ").concat(colors.white, ";\n  ");
}, function (_ref5) {
  var isKeyboardHover = _ref5.isKeyboardHover,
      isFocused = _ref5.isFocused;
  return isKeyboardHover && !isFocused && "\n    &:hover {\n      background: inherit;\n      color: inherit;\n    }\n  ";
}, function (_ref6) {
  var isSelected = _ref6.isSelected;
  return isSelected && "\n    background: ".concat(colors.sky, ";\n    color: ").concat(colors.white, ";\n    ");
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/listbox/dist/esm/styles.js
// module id = 4507
// module chunks = 11